import React, { useContext, useState } from "react";
import { Button, TextField, Box } from "@mui/material";
import Swal from "sweetalert2";

import { AuthContext } from "../../utils/userProvider";
import syncReservation from "../../mutation/system/syncReservation";
import Toast from "../../utils/Toast";
import {
  ListPageShell,
  ListPageCard,
  ListPageHeader,
} from "../../components/ListPage";

const ReservationSync = () => {
  const { authState } = useContext(AuthContext);
  const [reservationId, setReservationId] = useState("");

  const handleSync = async () => {
    const id = String(reservationId || "").trim();
    if (!id) {
      Toast.fire({
        icon: "error",
        title: "Please enter a reservation ID",
      });
      return;
    }

    Swal.fire({
      title: "Syncing Reservation",
      allowOutsideClick: false,
      allowEscapeKey: false,
      showCloseButton: false,
      showConfirmButton: false,
      willOpen: async () => {
        Swal.showLoading();
        try {
          const response = await syncReservation(
            { reservationId: id },
            authState ? authState.jwt : ""
          );
          Toast.fire({
            icon: "success",
            title: `Reservation ${id} synced successfully`,
          });
          Swal.close();
          if (response && response.data) {
            Swal.fire({
              icon: "success",
              title: `Sync ${response.data.action || "completed"}`,
              text: `Transaction ID: ${response.data.transactionId || "-"}`,
              allowOutsideClick: true,
              allowEscapeKey: true,
            });
          }
        } catch (err) {
          const errMsg =
            err &&
            err.errorMessage &&
            err.errorMessage.message &&
            err.errorMessage.message.message
              ? err.errorMessage.message.message
              : "An error has occured. Please try again.";
          Swal.fire({
            icon: "error",
            titleText: "Sync Failed",
            text: errMsg,
            allowOutsideClick: true,
            allowEscapeKey: true,
          });
        }
      },
    });
  };

  return (
    <ListPageShell>
      <ListPageCard sx={{ mt: 2.5 }}>
        <ListPageHeader title="Manual Reservation Sync" />
        <p>Enter RMS Reservation ID to sync/update this booking in middleware.</p>
        <TextField
          label="Reservation ID"
          variant="outlined"
          value={reservationId}
          onChange={(event) => setReservationId(event.target.value)}
        />
        <Box sx={{ mt: 2 }}>
          <Button variant="contained" color="primary" onClick={handleSync}>
            Sync Reservation
          </Button>
        </Box>
      </ListPageCard>
    </ListPageShell>
  );
};

export default ReservationSync;
